// src/components/Public/TagListings.js
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function TagListings() {
  const { tag } = useParams();
  
  return (
    <>
      <Helmet>
        <title>{tag.replace('-', ' ')} Properties | Property Listings</title>
      </Helmet>
      <div style={containerStyle}>
        <h1>Properties tagged as "{tag.replace('-', ' ')}"</h1>
        <p>This feature will be available soon. Tag-based filtering is coming!</p>
        <Link to="/" style={linkStyle}>← Back to All Properties</Link>
      </div>
    </>
  );
}

// Styles
const containerStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '40px 20px',
  textAlign: 'center',
};

const linkStyle = {
  display: 'inline-block',
  marginTop: '20px',
  padding: '10px 20px',
  backgroundColor: '#007bff',
  color: 'white',
  textDecoration: 'none',
  borderRadius: '5px',
  fontWeight: 'bold',
};

export default TagListings;